module.exports = __webpack_public_path__ + "static/media/活体认证_lg.04a00b1d.jpg";